export const locale = {
    lang: 'tr',
    data: {
      'DISPATCH': {
        'ENCUESTA_PILOTO': 'Test anketi',
        'ENCUESTA_PILOTO_ENVIO': 'Pilot anket gönderimi',
        'ENCUESTA_LANZAMIENTO':'Anket gönderimi',
        'BTN_COPY':'Anket anahtarını kopyala ',
        ////*******Tab Crear Encuestas********************************///
        'CREAR_ENCUESTA':'Anket oluştur',
        'ENCUESTA_DEMO':'Pilot anket',
        'BOTON_CREAR_ENCUESTA':'Anket oluştur',
        'SEE_TI': 'Teknik gereksinimlere bakın',
        'CLAVE': 'Erişim kodu',
        'ACCESO': 'Kod',
        'NOFECHA':'Bu eylemi yapamazsınız çünkü başlama tarihi yoktur',
        'LABEL01': 'Erişim kodunu kopyala/yapıştır kullanarak test anketine giriş yapabilirsiniz',
        'LABEL02': 'Anketin gönderilmesi onaylandı',
        'LABEL03': 'E-mail',
        'LABEL04': 'Pilot anketi gönder',
        'LABEL05': 'Hatalı bir durum oluştu',
        'LABEL06': 'Pilot anketi doğru şekilde gönderildi',
        'LABEL07': 'Gerekli alan',
        'LABEL09': 'Anket demo kullanıcıları tükendi',
        'CONFIRMAR_ENVIO': 'E-postaların gönderilmesini onayla',
        'DES_CONFIRMAR_ENVIO': 'E-postaların gönderilmesini onaylamayın',
        'SI_CONFIRMAR_ENVIO': 'Evet',
        'NO_CONFIRMAR_ENVIO': 'Hayır',
        'CHANGE-OPTIONS':'Posta Seçeneklerini Değiştir',
        'NO_ENVIO_CORREO':'Posta gönderilmeyecek',
        'SI_ENVIO_CORREO':'Postalar gönderilecek',
        'EN_CASO':'HAYIRı seçtiğinizde, anketle ilgili tüm iletişim platformun dışında olacaktır. Kullanıcılara hiçbir e-posta gönderilmeyecek.',
        'CONFIRMAR_ENVIO_35': 'Anket gönderimini onaylayın',
        'AUTOLOG_35': 'Anket otomatik girişi için bağlantı:',
        'TITULO':'Bu bölümde, anketin test çalışmasını yapabileceksiniz:',
        'LINK':'1. Aşağıdaki bağlantıya erişin:',
        'CLAVE_ENCUESTA':'2. Bu test anahtarını kopyalayın:',
        'INSTRUCCION3':'3. Anahtarı şifre hücresine yapıştırın',
        'INSTRUCCION4':'4. giriş tıklayın',
        'TEXTO_CONFIRMAR':'Kullanıcılarla iletişimin (Davet ve hatırlatıcılar) e-posta ile yapılacağını onaylayın',
        'TEXTO_CONFIRMAR2':'POSTALARIN GÖNDERİLMESİNİ İSTEMİYORSANIZ, tıklamayı atlayıp adımı kapatmanız yeterlidir.',
        'TITULO_PILOTO':'Bu bölümde anketi başlatmadan önce dilediğiniz 5 çalışana test amaçlı gönderim yaparak, anket hakkında görüşlerini alabilirsiniz:',
        'INSTRUCCION_PILOTO':"1. E-postaları girin ve daveti almak istediğiniz dili seçin",
        'INSTRUCCION_PILOTO2':'2. Gönder düğmesine tıklayın',
        'SELLANG': 'Bir dil seç',
        'MENSAJES':{
           'MSN_INGR_COD':'<span> Hiçbir davet veya hatırlatma e-postasının gönderilmeyeceğini onaylamak için, metin kutusuna kodu kırmızıyla girin ',
           'MSN_INGR_COD2':'</span>',
           'MSN_CHANGE-CONFI':'Yapılandırma değiştirildi',

        'BTN_MODALES':{
          'CONFIRMAR':'Onaylamak',
          'SALIR':'çıkış',
        }
        },
        'URL35':{ // Sive unicamente para dispatch de la norma 35
          'MAS50':'Daha 50',
          'MENOS50':'Daha az 50'
        },

        'CERTIFICAR2':{ // Sive unicamente para crear encuesta de certificar 2.0
          'LINK':'1. Aşağıdaki bağlantıya erişin:',
          'CLAVE_ENCUESTA':'2. "Demo kullanıcıları" bölümünde oluşturulan anahtarlardan birini kopyalayın',
          'INSTRUCCION3':'3. Anahtarı şifre hücresine yapıştırın',
          'INSTRUCCION4':'4. giriş tıklayın',
          'USERSDEMO':'Demo kullanıcıları',
          'USERS':'kullanıcı',
          'CLAVE':'anahtar',
          'ESTATUS':'Durum',
          'ESTATUS-USER-ASIGNA':'Atanmış',
          'INST_UPD_URL_NAME':'Kullanıcılarınızın aşina olduğu 6 karaktere kadar metin yazarak ShortUrlyi özelleştirin.',
          'BTN_UPD_GUARDA':'Kayıt etmek',
          'BTN_UPD_CAN':'İptal etmek',
          'CUS_SHOI_URL':'Anket URL sini Özelleştirin',
          'MODAL_ACTU_CUS_SHOI_URL':'URL deki adı güncelleme',
          'ACTU_CUS_SHOI_URL_OK':'URL deki ad doğru şekilde güncellendi',
          'ACTU_CUS_SHOI_URL_FALSE':'URL de isim zaten var',
        },


        'ALERT':{
            'HEADER':'Bilgi',
            'MESSAGE_CON': '¿Kullanıcılara e-posta gönderilmesini onaylamak istiyorsunuz?',
            'MESSAGE': '¿Ortak çalışanlarınıza e-posta gönderilmesini onaylamak istiyor musunuz?',
            'MESSAGE_DESCON': '¿Kullanıcılara e-posta gönderilmesini onaylamayacağınızdan emin olabilirsiniz.?',
            'BTN_CANCEL': 'Hayır, iptal et',
            'BTN_CONFIRM': 'Tamam, gönder',
            'BTN_NO_CONFIRM': 'Gönderi yok',
            'BTN_SI_CONFIRM': 'Gönderi Evet',
            'BTN_NO_CANCEL': 'iptal etmek',
            'BTN_OK': 'Tamam',
            'SINCOLABS': 'Henüz anket davetini gönderemezsiniz, önce şirket katılımcı listesini yüklemelisiniz.',
            'SINLANG': 'Girilen bir veya daha fazla e-posta adresi için henüz bir dil seçmediniz',
            'ERRMAIL': 'Girilen e-posta doğru sözdizimine sahip değil, kontrol edin ve tekrar girin'
        }

      },
      'PULSE':{
              'LABEL01': 'Anketi ortak çalışanlarınıza gönderin.',
      }
    }
};
